import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { InputDataObjectCreate } from './InputDataObjectCreate';
import { InputDataObjectDirectory } from './InputDataObjectDirectory';
import { FC } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './translations/InputDataObjects.translations.json';
import { InputDataObjectDetails } from './InputDataObjectDetails';
import { InputDataObjectEdit } from './InputDataObjectEdit';
import { DataObjectBreadcrumbsData } from '../data-objects/DataObjectBreadcrumbs';
import { NotFound } from '../NotFound';
import { InputDataObjectClone } from './InputDataObjectClone';

const { addTranslations, Translation } = i18nNsFactory('input-data-objects');
addTranslations(translations);

export const INPUT_DATA_OBJECT_ROUTES = [
  {
    path: path.inputDataObjectDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.input-data-objects')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <InputDataObjectDirectory />,
      },
      {
        path: path.inputDataObjectCreate,
        element: <InputDataObjectCreate />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.create-input-data-object')}
          </Translation>
        ),
      },
      {
        path: path.inputDataObjectView,
        renderBreadcrumb: (data?: DataObjectBreadcrumbsData) =>
          data?.dataObjectVersion ? (
            data.dataObjectVersion.code + ' - ' + data.dataObjectVersion.name
          ) : (
            <Translation>
              {(t) => t('breadcrumb.input-data-object-details')}
            </Translation>
          ),
        children: [
          {
            index: true,
            element: <InputDataObjectDetails />,
          },
        ],
      },
      {
        path: path.inputDataObjectEdit,
        element: <InputDataObjectEdit />,
        renderBreadcrumb: (data?: DataObjectBreadcrumbsData) =>
          data?.dataObjectVersion ? (
            data.dataObjectVersion.code + ' - ' + data.dataObjectVersion.name
          ) : (
            <Translation>{(t) => t('breadcrumb.edit-data-object')}</Translation>
          ),
      },
      {
        path: path.inputDataObjectClone,
        element: <InputDataObjectClone />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.clone-data-object')}</Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const InputDataObjects: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, INPUT_DATA_OBJECT_ROUTES));
